import 'css-chunk:src/components/pages/SearchPage/TextSearchFilters/CreatorAgeSection.scss';export default {
  "CreatorAgeSection": "_CreatorAgeSection_1orza_1",
  "checkboxes": "_checkboxes_1orza_1",
  "multiSelectContainer": "_multiSelectContainer_1orza_7",
  "multiSelectSelect": "_multiSelectSelect_1orza_12",
  "multiSelectSeparator": "_multiSelectSeparator_1orza_15",
  "column": "_column_1orza_18"
};